/* Full-screen phone gallery (Justyn 17/10/2026: "if the customer clicks on it the phone gallery goes full
   screen and can swipe left and right"). Tapping a photo in the phone gallery opens every photo of the
   gallery full screen, starting on the one tapped; swipe sideways between them, a counter shows where you
   are, and the close button (or Escape) brings you back to the same photo in the page gallery. Videos stay
   in the page and are skipped. Loaded by snippets/pdp-wellness.liquid. */
(function () {
  if (window.pdpGalleryFullscreen) return;
  window.pdpGalleryFullscreen = true;

  var phone = window.matchMedia('(max-width: 749px)');
  var overlay, track, counter, lastTrack, lastSlides, scrollY = 0;

  function bestSrc(img) {
    var set = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
    var best = '', bestW = 0;
    set.split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      var w = parseInt(bits[1], 10) || 0;
      if (bits[0] && w >= bestW) { best = bits[0]; bestW = w; }
    });
    return best || img.currentSrc || img.src;
  }

  function photoSlides(track) {
    return Array.prototype.filter.call(track.querySelectorAll('.pdp-gallery__slide'), function (s) {
      return !s.classList.contains('hidden') && !s.querySelector('video, [data-pdp-gallery-video]') && s.querySelector('img');
    });
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'pdp-fs';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product photos');
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="pdp-fs__bar"><span class="pdp-fs__count" aria-live="polite"></span>' +
      '<button type="button" class="pdp-fs__close" aria-label="Close photos">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>' +
      '</button></div><div class="pdp-fs__track"></div>';
    document.body.appendChild(overlay);
    track = overlay.querySelector('.pdp-fs__track');
    counter = overlay.querySelector('.pdp-fs__count');
    overlay.querySelector('.pdp-fs__close').addEventListener('click', close);
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (overlay.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') go(current() + 1);
      if (e.key === 'ArrowLeft') go(current() - 1);
    });
  }

  function current() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
  function go(i) { track.scrollTo({ left: Math.max(0, i) * track.clientWidth, behavior: 'smooth' }); }
  function sync() { if (lastSlides) counter.textContent = (current() + 1) + ' / ' + lastSlides.length; }

  function open(pageTrack, startSlide) {
    if (!overlay) build();
    lastTrack = pageTrack;
    lastSlides = photoSlides(pageTrack);
    var start = Math.max(0, lastSlides.indexOf(startSlide));
    track.innerHTML = '';
    lastSlides.forEach(function (s, i) {
      var img = s.querySelector('img');
      var cell = document.createElement('div');
      cell.className = 'pdp-fs__slide';
      var big = document.createElement('img');
      big.alt = img.alt || '';
      big.decoding = 'async';
      big.loading = Math.abs(i - start) <= 1 ? 'eager' : 'lazy';
      big.src = bestSrc(img);
      cell.appendChild(big);
      track.appendChild(cell);
    });
    scrollY = window.scrollY;
    document.documentElement.classList.add('pdp-fs-open');
    overlay.hidden = false;
    track.scrollLeft = start * track.clientWidth;
    sync();
    overlay.querySelector('.pdp-fs__close').focus({ preventScroll: true });
  }

  function close() {
    if (!overlay || overlay.hidden) return;
    var i = current();
    overlay.hidden = true;
    document.documentElement.classList.remove('pdp-fs-open');
    window.scrollTo(0, scrollY);
    // Leave the page gallery on the photo that was last viewed.
    var target = lastSlides && lastSlides[i];
    if (target && lastTrack) {
      var left = lastTrack.scrollLeft + (target.getBoundingClientRect().left - lastTrack.getBoundingClientRect().left);
      lastTrack.scrollTo({ left: left, behavior: 'auto' });
    }
  }

  document.addEventListener('click', function (e) {
    if (!phone.matches) return;
    var slide = e.target.closest('.pdp-redesign--well .pdp-gallery__mobile-hero .pdp-gallery__slide');
    if (!slide || slide.querySelector('video, [data-pdp-gallery-video]') || e.target.closest('a, button')) return;
    var pageTrack = slide.closest('[data-pdp-gallery-track]');
    if (!pageTrack) return;
    e.preventDefault();
    open(pageTrack, slide);
  });
})();
